module.exports = __webpack_public_path__ + "static/media/sc_17_i.de8fe2f6.png";